import styled from "styled-components";

// Read by assistive technology but never painted, for content the chart above it already shows sighted users.
export const VisuallyHidden = styled.div`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
`;
